<div style="margin-top: 10px;">
  <form [formGroup]="vesselForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Vessel
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="vesselDataSource" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Vessel Name</span>
                    <input placeholder="Search by Vessel Name" matInput
                      autocomplete="off" formControlName="name" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>
                <ng-container matColumnDef="operatorName">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Vessel Operator</span>
                      <input placeholder="Search by Operator Name" matInput type="search"
                        autocomplete="off" formControlName="operator" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.operatorName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Status</span>
                        <mat-select formControlName="status" placeholder="Search by Status">
                          @for (status of statusTypes; track status) {
                            <mat-option [value]="status.key">
                              {{status.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.status}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <span mat-sort-header>Action</span></th>
                      <td mat-cell *matCellDef="let element">
                        <span class="__action_edit_icon" (click)="openForm(element)">
                          <mat-icon mat-cell>create</mat-icon>
                        </span>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="groupColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
                  </table>
                </div>
              }

            </mat-card-content>
          </mat-card>
          @if (viewPermission) {
            <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalVesselRecords" showFirstLastButtons></mat-paginator>
          }
        </form>
      </div>
